import { nsMerchantUser } from '@/app/i18n/namespaces';

const CBVAD_CONTRACT_TYPES = {
    CONTACT: { value: 'CONTACT', name: 'CONTACT', namespace: nsMerchantUser },
    CONTACTLESS: { value: 'CONTACTLESS', name: 'CONTACTLESS', namespace: nsMerchantUser },
    VAD: { value: 'VAD', name: 'VAD', namespace: nsMerchantUser },
    CONTACT_AUTOMATE: { value: 'CONTACT_AUTOMATE', name: 'CONTACT_AUTOMATE', namespace: nsMerchantUser },
    CONTACTLESS_AUTOMATE: { value: 'CONTACTLESS_AUTOMATE', name: 'CONTACTLESS_AUTOMATE', namespace: nsMerchantUser }
};

export default CBVAD_CONTRACT_TYPES;